import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/industry.jpg");
;
import(/* webpackMode: "eager" */ "/app/src/assets/images/notfound.jpg");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/PrimaryButton.js");
